module.exports = {
	baseURL: "/",
	baseRoute: "/*",
	version: "4f83fdb",
	host: "https://chemnet.berkeley.edu/chemnet",
	reactHost: "https://chemnet.berkeley.edu",
}
